import { IGenericError, WellhubSlotDetails } from '@libs/entity-lib';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './wellhub.actions';

export interface State {
  loading: boolean;
  slotDetails: WellhubSlotDetails | null;
  error: IGenericError | null;
}

export const initialState: State = {
  loading: false,
  slotDetails: null,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.fetchSlotDetails, (state) => ({ ...state, loading: true })),
  on(fromActions.fetchSlotDetailsSuccessfuly, (state, { slotDetails }) => ({
    ...state,
    slotDetails,
    loading: false,
  })),
  on(fromActions.fetchSlotDetailsFailed, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
